import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import FootballCoverage from '../components/FootballCoverage';
import Features from '../components/Features';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

/** Marketing home page — same content as the original single-page App. */
export default function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white selection:bg-brand-500 selection:text-white">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <FootballCoverage />
        <Features />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
